import RateInfoDropdown from './RateInfoDropdown';

export default RateInfoDropdown;
